import {BaseQueryFn, createApi} from '@reduxjs/toolkit/query/react'
import {tokenProvider} from '../services/tokenProvider'
import {config} from '../config'

const getBackendUrl = (): string => {
    return config.backendUrl || 'http://localhost:8081/'
}

const customBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
    const {url, method = 'GET', body, params, headers} = args as any

    const authHeader = tokenProvider.getAuthHeader()

    const requestHeaders: HeadersInit = {
        'Content-Type': 'application/json',
        ...(headers || {}),
    }

    if (authHeader) {
        requestHeaders['authorization'] = authHeader
    }

    const filteredParams = params ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== undefined && v !== '')
    ) as Record<string, string> : undefined

    const queryString = filteredParams ? new URLSearchParams(filteredParams).toString() : ''
    const fullUrl = `${getBackendUrl()}${url}${queryString ? `?${queryString}` : ''}`

    try {
        const response = await fetch(fullUrl, {
            method,
            headers: requestHeaders,
            body: body ? JSON.stringify(body) : undefined,
        })

        const contentType = response.headers.get('content-type') || ''

        if (!response.ok) {
            const errorData = await response.json()
            return {
                error: {
                    status: response.status,
                    data: errorData,
                },
            }
        }

        if (contentType.includes('text/html')) {
            const htmlText = await response.text()
            return {data: htmlText}
        }

        // Handle empty response body (e.g., 200 OK with no content)
        const textData = await response.text()
        if (!textData || textData.trim() === '') {
            return {data: null}
        }

        const jsonData = JSON.parse(textData)
        return {data: jsonData}
    } catch (error) {
        return {
            error: {
                status: 500,
                data: error,
            },
        }
    }
}

export const emptyApi = createApi({
    reducerPath: 'api',
    baseQuery: customBaseQuery,
    tagTypes: ['User', 'Auth', 'Admin', 'Portal', 'Users', 'PortalLicenses', 'PortalTeam', 'Products', 'EmailChange', 'AlumniAcceptance'],
    endpoints: () => ({}),
})

// Export as 'api' for compatibility with RTK Query codegen
export const api = emptyApi
